import type { AnySchema } from 'yup';

/**
 * Удобная обертка для Yup.
 * Возвращает функцию валидации элемента формы.
 * @param schema
 */
export const fieldValidator =
  <T>(schema: AnySchema<T>): ((value: unknown) => string | undefined) =>
  (value: unknown): string | undefined => {
    try {
      schema.validateSync(value);
    } catch (err: any) {
      return err.message;
    }

    return undefined;
  };
